export default __webpack_public_path__ + "static/media/izvestaj-o-statusnoj-promeni.e925c9f5.pdf";